/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppCommerceDataSchema } from "@schemas/message/whatsAppCommerceDataSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// Refer to WhatsAppResponseMessageSingleProductExport
export const whatsAppResponseSingleProductMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("single-product"),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  commerce_data: whatsAppCommerceDataSchema,
});
